export const SITE_URL = 'https://behson.co.uk';
export const SITE_NAME = 'Behson Property Solutions';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/brand/og-default.jpg`;

export const PAGE_OG_IMAGES: Record<string, string> = {
  '/': `${SITE_URL}/Kitchen.jpeg`,
  '/about': `${SITE_URL}/outdoor.jpeg`,
  '/plumbing': `${SITE_URL}/Bathroom.jpeg`,
  '/renovations': `${SITE_URL}/Kitchen.jpeg`,
  '/maintenance': `${SITE_URL}/Roof2.jpeg`,
  '/contact': `${SITE_URL}/outdoor.jpeg`,
  '/portfolio': `${SITE_URL}/outdoor.jpeg`,
  '/gallery': `${SITE_URL}/Garden.jpeg`,
  '/testimonials': `${SITE_URL}/Kitchen.jpeg`,
  '/locations': `${SITE_URL}/outdoor2.jpeg`,
};

export const SERVICE_AREAS = [
  'Kingsbury',
  'Colindale',
  'Edgware',
  'Queensbury',
  'Hendon',
  'Wembley',
  'Harrow',
  'Burnt Oak',
];

export const LOCAL_BUSINESS_ID = `${SITE_URL}/#business`;

/** Shared LocalBusiness entity. Referenced by @id from Service schema on service pages. */
export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'HomeAndConstructionBusiness', 'Plumber'],
  '@id': LOCAL_BUSINESS_ID,
  name: SITE_NAME,
  url: SITE_URL,
  image: `${SITE_URL}/Kitchen.jpeg`,
  logo: `${SITE_URL}/brand/icon-512.png`,
  description:
    'Plumbing, kitchen and bathroom renovation, house renovation and property maintenance in Kingsbury, NW9 and North West London.',
  telephone: '+447988682289',
  email: 'behson@live.com',
  priceRange: '££',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Kingsbury',
    addressRegion: 'London',
    postalCode: 'NW9',
    addressCountry: 'GB',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 51.5845, longitude: -0.2786 },
  areaServed: SERVICE_AREAS.map((name) => ({ '@type': 'Place', name })),
  sameAs: ['https://www.instagram.com/behsonuk/'],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  inLanguage: 'en-GB',
  publisher: { '@id': LOCAL_BUSINESS_ID },
};

export type Crumb = { name: string; path: string };

export const breadcrumbSchema = (crumbs: Crumb[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [{ name: 'Home', path: '/' }, ...crumbs].map((crumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: crumb.name,
    item: `${SITE_URL}${crumb.path === '/' ? '' : crumb.path}`,
  })),
});

export const serviceSchema = (input: {
  name: string;
  description: string;
  path: string;
  serviceType: string;
  image?: string;
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: input.name,
  serviceType: input.serviceType,
  description: input.description,
  url: `${SITE_URL}${input.path}`,
  image: input.image,
  provider: { '@id': LOCAL_BUSINESS_ID },
  areaServed: SERVICE_AREAS.map((name) => ({ '@type': 'Place', name })),
});

export type Faq = { question: string; answer: string };

export const faqSchema = (faqs: Faq[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
  })),
});
